"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentHooks = void 0;
const bluebird_1 = __importDefault(require("bluebird"));
const constants_1 = require("@powerednow/shared/constants");
const getDocumentHooks = (useComplexData) => {
    const useQuotesByCustomer = (customerId) => useComplexData('Customer', customerId, async (complexCustomer, resultSetter) => {
        const quotes = await complexCustomer.getAllQuote();
        const sortedQuotes = quotes.toSorted((a, b) => b.data.documentnumber - a.data.documentnumber);
        const { filteredDocuments, notFullyInvoicedQuotes } = await bluebird_1.default.reduce(sortedQuotes, async (acc, document) => {
            if (document.data.status !== constants_1.DOCUMENT.STATUS.REJECTED) {
                acc.filteredDocuments.push(document);
                if (!await document.isQuoteFullyInvoiced()) {
                    acc.notFullyInvoicedQuotes.push(document);
                }
            }
            return acc;
        }, { filteredDocuments: [], notFullyInvoicedQuotes: [] });
        const documentsToShow = notFullyInvoicedQuotes.length ? notFullyInvoicedQuotes : filteredDocuments;
        const quotesWithExtraData = await bluebird_1.default.map(documentsToShow, async (item) => {
            const jobItemGroups = await item.getJobItemGroups(constants_1.DOCUMENT.DOCUMENT_ITEMS.TYPES.JOB_ITEM_GROUP);
            const summariesList = [];
            await bluebird_1.default.each(jobItemGroups, async (itemGroup) => {
                const jobItems = await itemGroup.getAllJobItem();
                return jobItems.forEach(jobItem => summariesList.push(jobItem.data.description));
            });
            const quoteTotal = await item.getDocumentTotals();
            return {
                ...item.data.getDataValues(),
                accepted: quoteTotal.accepted,
                alreadyInvoicedAmount: await item.getAlreadyInvoicedAmount(),
                isAutoCreated: await item.isAutoCreated(),
                displayStatusPrompt: item.getStatusStringPrompt(),
                displayedSummaries: summariesList,
            };
        });
        resultSetter({
            //
            // We want to filter out quotes that do not have pricing
            //
            documents: quotesWithExtraData.filter(item => item.displayedSummaries.length > 0),
            hasNotFullyPaidDocuments: Boolean(notFullyInvoicedQuotes.length),
            loaded: true,
        });
    });
    const usePurchaseOrdersByCustomer = (customerId, supplierId) => {
        const result = useComplexData('Customer', supplierId, async (complexCustomer, resultSetter) => {
            const orders = await complexCustomer.getAllPurchaseOrder();
            const reducedOrders = await bluebird_1.default.reduce(orders, async (innerAcc, item) => {
                if (item.isApproved()) {
                    const job = await item.getJob();
                    if (job.data.customer_id === customerId) {
                        innerAcc.push(item.data.getDataValues());
                    }
                }
                return innerAcc;
            }, []);
            resultSetter({ documents: reducedOrders, loaded: true });
        });
        return result;
    };
    return {
        useQuotesByCustomer,
        usePurchaseOrdersByCustomer,
    };
};
exports.getDocumentHooks = getDocumentHooks;
//# sourceMappingURL=../../../../src/models/document/hooks.js.map